const rawBase = process.env.REACT_APP_ZOOM_API_BASE || '';
const apiBase = rawBase.endsWith('/') ? rawBase.slice(0, -1) : rawBase;

async function parseResponse(res, fallbackMessage) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || fallbackMessage);
  }
  return payload;
}

// Returns teachers (role=teacher) from the database.
export async function getMentors() {
  const res = await fetch(`${apiBase}/api/demos/mentors`);
  return parseResponse(res, 'Unable to load mentors.');
}

// Schedule a demo invite. salesPersonEmail is CC'd on the outgoing email.
export async function scheduleDemoInvite({ email, mentorId, timeSlot, prospectName, notes, salesPersonEmail }) {
  const res = await fetch(`${apiBase}/api/demos/invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, mentorId, timeSlot, prospectName, notes, salesPersonEmail }),
  });
  return parseResponse(res, 'Unable to schedule demo.');
}

export async function getDemoInvites(email) {
  const res = await fetch(`${apiBase}/api/demos/invite?email=${encodeURIComponent(email)}`);
  return parseResponse(res, 'Unable to load demo invitations.');
}

export async function getDemoQueue() {
  const res = await fetch(`${apiBase}/api/demos/queue`);
  return parseResponse(res, 'Unable to load demo queue.');
}
